import { render } from "./AttachmentForm.vue?vue&type=template&id=8753c332"
import script from "./AttachmentForm.vue?vue&type=script&lang=js"
export * from "./AttachmentForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__